import { HTMLAttributes } from 'react';
import { useRecoilValue } from 'recoil';

import classNames from 'classnames';

import { THEME_INFO } from 'styles/stylesProvider/themes';
import { themeState } from 'components/common/Managers/SettingsManager.state';
import { getDataSourceLogo } from 'plugins/deep-visibility/datasource-logos';
import { Schema } from 'schemas';

import './DataSourceIcon.scss';

type DataSourceIconProps = HTMLAttributes<HTMLDivElement> & {
  className?: string;
  schema?: Schema;
};

function DataSourceIcon({ className, schema, ...props }: DataSourceIconProps): JSX.Element {
  const theme = useRecoilValue(themeState);
  const themeInfo = THEME_INFO[theme];
  const label = schema?.dataSourceLabel;
  const logo = getDataSourceLogo(schema?.dataSource, themeInfo);

  return (
    <>
      {logo && (
        <div {...props} className={classNames('DataSourceIcon', className)}>
          <img src={logo} alt={label} />
        </div>
      )}
    </>
  );
}

export default DataSourceIcon;
